<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลประเภทพื้นที่
        </div>
        <div class="txt-head black--text mb-2">
          1. ข้อมูลประเภทผู้ใช้บริการพื้นที่ (User Type)
          เลือกตอบเพียงประเภทเดียว
        </div>
        <!-- Form 1 -->
        <div>
          <v-radio-group style="width: 100%" v-model="form.area_form_1_type_id">
            <v-radio
              v-for="(item, index) in masterData?.user_type"
              :key="index"
              :label="item.name"
              :value="item.id"
              color="var(--theme-color-one)"
              class="pl-5"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "FirstForm",
  components: {},
  props: {
    masterData: Object,
    formData: Object,
  },
  data() {
    return {
      form: {
        area_form_1_type_id: null,
      },
    };
  },
  computed: {
    ...mapState({}),
  },
  created() {
    eventBus.$on("firstForm", () => {
      eventBus.$emit("firstFormSend", this.form);
    });
    eventBus.$emit("firstFormSend", this.form);
  },
  methods: {},
};
</script>

<style scoped></style>
